export default function TimeIcon(){
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0001 11.0007L7.08327 7.73664C6.50132 7.25169 6.21035 7.00921 6.00117 6.71197C5.81582 6.4486 5.67818 6.15473 5.59451 5.84374C5.50008 5.49275 5.50008 5.11399 5.50008 4.35647V1.83398M11.0001 11.0007L14.9169 7.73664C15.4988 7.25169 15.7898 7.00921 15.999 6.71197C16.1843 6.4486 16.322 6.15473 16.4057 5.84374C16.5001 5.49275 16.5001 5.11399 16.5001 4.35647V1.83398M11.0001 11.0007L7.08327 14.2647C6.50132 14.7496 6.21035 14.9921 6.00117 15.2893C5.81582 15.5527 5.67818 15.8466 5.59451 16.1576C5.50008 16.5085 5.50008 16.8873 5.50008 17.6448V20.1673M11.0001 11.0007L14.9169 14.2647C15.4988 14.7496 15.7898 14.9921 15.999 15.2893C16.1843 15.5527 16.322 15.8466 16.4057 16.1576C16.5001 16.5085 16.5001 16.8873 16.5001 17.6448V20.1673M3.66675 1.83398H18.3334M3.66675 20.1673H18.3334"
        stroke="#656565"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

}